import FileSaver from 'file-saver'
import React, { useEffect, useState } from 'react'
import { Button, Table } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { useSelector } from 'react-redux'
import { useImmer } from 'use-immer'
import Loader from '../../components/Loader'
import SearchBox from '../../components/Searchbox'
import CustomToast from '../../components/Toast/CustomToast'
import { customStyles } from '../../components/customStyles'
import {
  calculatePageRange,
  encodedSearchText,
  showToast
} from '../../lib/AllGlobalFunction'
import { allCrudNames, allPages, checkPageAccess } from '../../lib/AllPageNames'
import { pageRangeDisplayed } from '../../lib/AllStaticVariables'
import axiosProvider from '../../lib/AxiosProvider'
import { getBaseUrl, getDeviceId, getUserToken } from '../../lib/GetBaseUrl'
import { _exception } from '../../lib/exceptionMessage'
import useDebounce from '../../lib/useDebounce'

const InvoiceList = () => {
  const [searchText, setSearchText] = useState()
  const [loading, setLoading] = useState(true)
  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 50,
    pageIndex: 1,
    searchText: ''
  })
  const [modalShow, setModalShow] = useState({ show: false, data: null })
  const { pageAccess } = useSelector((state) => state.user)
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const [data, setData] = useState()
  const debounceSearchText = useDebounce(searchText, 500)

  useEffect(() => {
    if (debounceSearchText) {
      setFilterDetails((draft) => {
        draft.searchText = debounceSearchText
        draft.pageIndex = 1
      })
    } else {
      setFilterDetails((draft) => {
        draft.searchText = ''
        draft.pageIndex = 1
      })
    }
  }, [debounceSearchText])

  const handlePageClick = (event) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setFilterDetails((draft) => {
      draft.pageIndex = event.selected + 1
    })
  }

  const fetchData = async () => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'Admin/Order/CustomerInvoice',
      queryString: `?searchText=${encodedSearchText(
        filterDetails?.searchText
      )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
        filterDetails?.pageSize
      }`
    })
    setLoading(false)
    if (response?.status === 200) {
      setData(response)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filterDetails])

  return (
    <>
      <div className='d-flex align-items-center mb-3 gap-3 flex-row justify-content-between'>
        <div className='d-flex gap-3 align-items-center'>
          <SearchBox
            placeholderText={'Search'}
            value={searchText}
            searchclassnamewrapper={'searchbox-wrapper'}
            onChange={(e) => {
              setSearchText(e?.target?.value)
            }}
          />

          <div className='page-range'>
            {calculatePageRange({
              ...filterDetails,
              recordCount: data?.data?.pagination?.recordCount ?? 0
            })}
          </div>

          <div className='d-flex align-items-center'>
            <label className='me-1'>Show</label>
            <select
              styles={customStyles}
              menuPortalTarget={document.body}
              name='dataget'
              id='parpageentries'
              className='form-select me-1'
              value={filterDetails?.pageSize}
              onChange={(e) => {
                setFilterDetails((draft) => {
                  draft.pageSize = e?.target?.value
                  draft.pageIndex = 1
                })
              }}
            >
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
              <option value='100'>100</option>
              <option value='200'>200</option>
              <option value='500'>500</option>
            </select>
          </div>
        </div>
      </div>

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {loading && <Loader />}

      <Table responsive className='align-middle table-list'>
        <thead>
          <tr>
            <th>Order No.</th>
            <th>Package No.</th>
            <th>No. of package</th>
            <th>Invoice Amount</th>
            {checkPageAccess(pageAccess, allPages?.manageInvoice, [
              allCrudNames?.update,
              allCrudNames?.delete
            ]) && <th className='text-center'>Action</th>}
          </tr>
        </thead>
        <tbody>
          {data?.data?.data?.length > 0 ? (
            data?.data?.data?.map((innerData, index) => (
              <tr key={Math.floor(Math.random() * 100000)}>
                <td>{innerData?.orderNo}</td>
                <td>{innerData?.packageNo}</td>
                <td>{innerData?.noOfPackage}</td>
                <td>{innerData?.invoiceAmount}</td>
                <td>
                  <div className='d-flex align-items-center gap-3'>
                    {checkPageAccess(pageAccess, allPages?.manageInvoice, [
                      allCrudNames?.update,
                      allCrudNames?.delete
                    ]) && (
                      <Button
                        variant='primary'
                        onClick={async () => {
                          if (innerData?.packageID) {
                            let downloadUrl = `${getBaseUrl()}/GenerateInvoice/GenerateInvoice?Packageid=${
                              innerData?.packageID
                            }`
                            let headers = new Headers()
                            headers.append(
                              'Authorization',
                              `Bearer ${getUserToken()}`
                            )
                            headers.append('device_id', `${getDeviceId()}`)
                            setLoading(true)
                            fetch(downloadUrl, {
                              method: 'POST',
                              headers: headers
                            })
                              .then((response) => {
                                setLoading(false)
                                const blob = response.blob()
                                return blob
                              })
                              .then((blob) => {
                                const customFileName = `${innerData?.orderNo}.pdf`
                                FileSaver.saveAs(blob, customFileName)
                              })
                          } else {
                            setLoading(false)
                            showToast(toast, setToast, {
                              data: {
                                message: _exception?.message,
                                code: 204
                              }
                            })
                          }
                        }}
                      >
                        Invoice
                      </Button>
                    )}
                    {checkPageAccess(pageAccess, allPages?.manageInvoice, [
                      allCrudNames?.update,
                      allCrudNames?.delete
                    ]) && (
                      <Button
                        onClick={async () => {
                          if (innerData?.packageID) {
                            let downloadUrl = `${getBaseUrl()}/GenerateInvoice/GenerateShippingLabel?Packageid=${
                              innerData?.packageID
                            }`
                            let headers = new Headers()
                            headers.append(
                              'Authorization',
                              `Bearer ${getUserToken()}`
                            )
                            headers.append('device_id', `${getDeviceId()}`)
                            setLoading(true)
                            fetch(downloadUrl, {
                              method: 'POST',
                              headers: headers
                            })
                              .then((response) => {
                                setLoading(false)
                                const blob = response.blob()
                                return blob
                              })
                              .then((blob) => {
                                const customFileName = `${innerData?.orderNo}.pdf`
                                FileSaver.saveAs(blob, customFileName)
                              })
                          } else {
                            setLoading(false)
                            showToast(toast, setToast, {
                              data: {
                                message: _exception?.message,
                                code: 204
                              }
                            })
                          }
                        }}
                        variant='outline-primary'
                      >
                        Label
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={10} className='text-center'>
                {data?.data?.message}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {data?.data?.pagination?.pageCount > 0 && (
        <ReactPaginate
          className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
          breakLabel='...'
          nextLabel=''
          onPageChange={handlePageClick}
          pageRangeDisplayed={pageRangeDisplayed}
          pageCount={data?.data?.pagination?.pageCount}
          previousLabel=''
          renderOnZeroPageCount={null}
          forcePage={filterDetails?.pageIndex - 1}
        />
      )}
    </>
  )
}

export default InvoiceList
